'use strict';

module.exports = [
    '$mdUtil',
    function  ( $mdUtil ) {

        return {
        require: ['ngModel', 'rmRelatedBroadcastPicker'],
        restrict: 'E',
        scope: {
            minDate: '=mdMinDate',
            maxDate: '=mdMaxDate',
            triggerMonthIndex: '=rmTriggerMonthIndex',
            onChange: '=ngChange',
            dateFilter: '=mdDateFilter',
            dateFilterUpdateCtrl: '=rmDateFilterUpdate'
        },
        controller: ['$scope', '$element', '$window', '$$rAF' ,RelatedBroadastCtrl],
        controllerAs: 'ctrl',
        templateUrl: '/partial/app.directives.related_broadcasts',
        link: function (scope, element, attributes, controllers) {

            var ngModelCtrl = controllers[0];
            var RelatedBroadastCtrl = controllers[1];
                RelatedBroadastCtrl.configureNgModel(ngModelCtrl);
        }
    };

    function RelatedBroadastCtrl ( $scope, $element, $window, $$rAF ) {

        this.documentElement = angular.element(document.documentElement);
        this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
        this.$window = $window;
        this.$$rAF = $$rAF;
        this.triggerMonthIndex = $scope.triggerMonthIndex;
        this.dateFilter = $scope.dateFilter;
        this.dateFilterUpdate = $scope.dateFilterUpdateCtrl;

        //Listen to onChange event calender view
        $scope.$on('md-calendar-change', (event, date) => {

            $scope.onChange( date );
        });

        this.configureNgModel = function(ngModelCtrl) {

            this.ngModelCtrl = ngModelCtrl;

            // Responds to external changes to the model value.
            this.ngModelCtrl.$formatters.push( (value) => {

                var parsedValue = angular.isDefined(value) ? Date.parse(value) : null;

                // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
                if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
                    value = new Date(parsedValue);

                    this.date = value;
                }

                if (value && !(value instanceof Date)) {
                    throw Error(
                        'The ng-model for md-datepicker must be a Date instance or a value ' +
                        'that can be parsed into a date. Currently the model is of type: ' + typeof value
                    );
                }
                return value;
            });
        }

        this.openCalendarPane = (event) => {

            this.isCalendarOpen = true;

            this.attachCalendarPane();

            $mdUtil.nextTick( () => {

                this.documentElement.on('click touchstart', this.handleBodyClick);
            }, false);
        }


        this.handleBodyClick = () => {

            if (this.isCalendarOpen) {

                this.closeCalendarPane();
                $scope.$digest();
            }
        };

        this.attachCalendarPane = () => {

            var calendarPane = this.calendarPane;
            var body = document.body;
            var elementRect = $element[0].getBoundingClientRect();
            var bodyRect = body.getBoundingClientRect();
            var paneLeft = elementRect.left - bodyRect.left;

            var paneTop = elementRect.top - bodyRect.top;

            calendarPane.style.left = paneLeft + 'px';
            calendarPane.style.top = paneTop + 'px';
            document.body.appendChild(calendarPane);

            this.$$rAF(function() {
                calendarPane.classList.add('md-pane-open');
            });
        }

        this.closeCalendarPane = () =>
        {
            this.detachCalendarPane();
            this.documentElement.off('click touchstart', this.handleBodyClick);
            this.isCalendarOpen= false;
        }

        this.detachCalendarPane = () => {
            this.calendarPane.classList.remove('md-pane-open');
            if (this.calendarPane.parentNode) {
                // Use native DOM removal because we do not want any of the
                // angular state of this element to be disposed.
                this.calendarPane.parentNode.removeChild(this.calendarPane);
            }

        }
    }
}]